module.exports = __webpack_public_path__ + "static/mixi-b7eaee9c089c923a25e4d591950d6831.svg";